<template>
  <header id="header">
    <div class="grid_wrapper">
      <div
        class="upper_grid"
        @click="updateScroll"
      >
        <router-link to="/select">
          <div class="logo_wrapper">
              <span class="house_icon"></span>
              <h2 class="main_logo">
                <span>エネルギー消費性能計算プログラム</span>
                <span class="selected_program_jutaku">住宅版</span>
                <span class="selected_program_ees">特定建築主基準版</span>
                <span class="selected_program_trad">気候風土適応住宅版</span>
                
                <span class="root title_simple">簡易入力画面</span>
                <span class="root title_detail">詳細入力画面</span>
                <span class="version">{{ version }}</span>
              </h2>
          </div>
        </router-link>
      </div>
      <div
        :class="{ open: foldIsShow }"
        class="lower_grid"
      >
        <div class="lower_white_box">
          <div class="title_command">
            <span>計算条件の入力</span>
            <app-button
              value="読込"
              @button-click="showLoad"
              this-class="load"
            />
            <app-button
              value="保存"
              @button-click="showSave"
              this-class="save"
            />
          </div>
        </div>
      </div>
      <div :class="{ open: foldIsShow , right_grid:true}">
        <!-- TODO 計算ボタンを押した後に「計算結果」へのリンクをアクティブにする -->
        <app-button
          @button-click="toResult"
          value="計算結果の確認"
          this-class="toresult"
          :class="{ 'notactive' : !isResult}"
        /><!-- 計算結果の確認ボタン -->
        <app-button
          @button-click="Calc"
          value="計算"
          this-class="keisan"
        /><!-- 計算ボタン -->
      </div>
      <div :class="{ open: foldIsShow, nav_box:true, nav_simple:true }">
          <ul>
            <li
              :class="{ active: axis.basic <= 201 && 201 < axis.envelope || axis.basic == null}"
              @click="toggleMenu"
            >
              <router-link to="/simple/#basic" name="基本情報">基本情報</router-link>
            </li>
            <li
              :class="{ active: axis.envelope <= 201 && 201 < axis.heating}"
              @click="toggleMenu"
            >
              <router-link to="/simple/#envelope" name="外皮">外皮</router-link>
            </li>
            <li
              :class="{ active: axis.heating <= 201 && 201 < axis.cooling}"
              @click="toggleMenu"
            >
              <router-link to="/simple/#heating" name="暖房">暖房</router-link>
            </li>
            <li
              :class="{ active: axis.cooling <= 201 && 201 < axis.ventilation}"
              @click="toggleMenu"
            >
              <router-link to="/simple/#cooling" name="冷房">冷房</router-link>
            </li>
            <li
              :class="{ active: axis.ventilation <= 201 && 201 < axis.hotwater}"
              @click="toggleMenu"
            >
              <router-link to="/simple/#ventilation" name="換気">換気</router-link>
            </li>
            <li
              :class="{ active: axis.hotwater <= 201 && 201 < axis.lighting}"
              @click="toggleMenu"
            >
              <router-link to="/simple/#hotwater" name="給湯">給湯</router-link>
            </li>
            <li
              :class="{ active: axis.lighting <= 201 && axis.basic !== null}"
              @click="toggleMenu"
            >
              <router-link to="/simple/#lighting" name="照明">照明</router-link>
            </li>
          </ul>
          <div class="uq_moveToDetail">
            <app-button
                  value="詳細入力画面に移動する"
                  @button-click="moveConfirm"
              />
              <span>このページで入力した内容を保持して<br />詳細入力画面に移動します</span>
          </div>
      </div>
      <div :class="{ open: foldIsShow, nav_box:true, nav_detail:(category=='detail'), nav_trad:(category=='trad'), nav_ees:(category=='ees')}" v-for="category in ['detail', 'ees', 'trad']" :key="category">
          <ul>
            <li
              :class="{ active: $route.path === '/' + category + '/basic' || $route.path === '/' + category || $route.path === '/' + category + '/' }"
              @click="toggleMenu"
            >
              <router-link :to="'/' + category + '/basic'">基本情報</router-link>
            </li>
            <li
              :class="{ active: $route.path === '/' + category + '/envelope'}"
              @click="toggleMenu"
            >
              <router-link :to="'/' + category + '/envelope'" name="外皮">外皮</router-link>
            </li>
            <li
              :class="{ active: $route.path === '/' + category + '/heating'}"
              @click="toggleMenu"
            >
              <router-link :to="'/' + category + '/heating'" name="暖房">暖房</router-link>
            </li>
            <li
              :class="{ active: $route.path === '/' + category + '/cooling'}"
              @click="toggleMenu"
            >
              <router-link :to="'/' + category + '/cooling'" name="冷房">冷房</router-link>
            </li>
            <li
              :class="{ active: $route.path === '/' + category + '/ventilation'}"
              @click="toggleMenu"
            >
              <router-link :to="'/' + category + '/ventilation'" name="換気">換気</router-link>
            </li>
            <li
              :class="{ active: $route.path === '/' + category + '/heat-exchanger'}"
              @click="toggleMenu"
            >
              <router-link :to="'/' + category + '/heat-exchanger'" name="熱交換">熱交換</router-link>
            </li>
            <li
              :class="{ active: $route.path === '/' + category + '/hotwater'}"
              @click="toggleMenu"
            >
              <router-link :to="'/' + category + '/hotwater'" name="給湯">給湯</router-link>
            </li>
            <li
              :class="{ active: $route.path === '/' + category + '/lighting'}"
              @click="toggleMenu"
            >
              <router-link :to="'/' + category + '/lighting'" name="照明">照明</router-link>
            </li>
            <li
              :class="{ active: $route.path === '/' + category + '/pv'}"
              @click="toggleMenu"
            >
              <router-link :to="'/' + category + '/pv'" name="太陽光">太陽光</router-link>
            </li>
            <li
              :class="{ active: $route.path === '/' + category + '/solar'}"
              @click="toggleMenu"
            >
              <router-link :to="'/' + category + '/solar'" name="太陽熱">太陽熱</router-link>
            </li>
            <li
              :class="{ active: $route.path === '/' + category + '/cogene'}"
              @click="toggleMenu"
            >
              <router-link :to="'/' + category + '/cogene'" name="コージェネ">コージェネ</router-link>
            </li>
          </ul>
      </div>
      <div class="white_box">
        <span
          v-if="foldIsShow"
          @click="toggleMenu"
          class="btn_menu"
        >
          = 閉じる =
        </span>
        <span
          v-else
          @click="toggleMenu"
          class="btn_menu"
        >
          = メニュー =
        </span>
      </div>
    </div>
  </header>
</template>


<script>
/**
 * 共通ヘッダ
 * 
 * [プロパティ]
 * foldIsShow ... 折り畳みメニューの表示非表示を制御
 * 
 * [算出プロパティ]
 * isResult ... 計算結果を保持しているか否か。計算結果の確認画面への遷移が可能かの判定に使用
 * routeIsNotResult ... 計算結果画面が表示されているかの判定。NavigationDuplicate回避のための判定。
 * 
 * [イベント処理]
 * 計算結果の確認ボタンクリック時 ... 計算結果を保持していれば計算結果画面へ遷移
 * 計算ボタンクリック時 ... 計算を実行し、折り畳みメニューを閉じる
 * 簡易版のスクロール時 ... スクロール後の座標を取得
 * 保存ボタン押下時 ... this.$emit('show-save')
 * 読み込みボタン押下時 ... this.$emit('show-load')
 * ハンバーガーメニュー内ボタンクリック時など ... this.$emit('toggle-menu')
 * 
 * [利用例]
 * <layout-header
 *   @show-save="showSave"
 *   @modal-save-hide="hideSave"
 *   @show-load="showLoad"
 *   @modal-load-hide="hideLoad"
 *   @toggle-menu="toggleMenu"
 *   :fold-is-show="foldIsShow"
 * />
 * 
 * [データ]
 * axis ... 各項目のTOP位置と現在の座標との差を保存するObject
 */
import evaluate from "@/mixins/eval"
import { mapGetters, mapActions } from 'vuex'

export default {
    name:"LayoutHeader",
    data(){
        return {
            /**
             * 簡易用：各項目のTOP位置と現在の座標との差を保存するObject
             */
            axis:{
              /**
               * 基本情報
               */
              basic: null,
              /**
               * 外皮
               */
              envelope: null,
              /**
               * 暖房
               */
              heating: null,
              /**
               * 冷房
               */
              cooling: null,
              /**
               * 給湯
               */
              hotwater: null,
              /**
               * 給湯
               */
              ventilation: null,
              /**
               * 照明
               */
              lighting: null,
            }
        }
    },
    mixins:[evaluate],
    props: {
      /**
       * 折り畳みメニューの表示非表示を制御
       */
        foldIsShow: {
          type:Boolean
        },
    },
    computed:{
      ...mapGetters({
        /**
         * 計算結果を保持しているか否か。計算結果の確認画面への遷移が可能かの判定に使用
         */
        isResult: 'view/isResult',
        /**
         * バージョン番号の取得
         */
        version: 'general/getVersion',
      }),
      /**
       *  NavigationDuplicate回避のための判定。計算結果が出ているときに計算させない形になっている
       */
      routeIsNotResult(){
        return (!this.$route.name.includes('result'))
      },
    },
    methods: {
      /**
       * 計算結果を保持していれば計算結果画面へ遷移
       */
      toResult(){
        if(this.isResult){
          this.$router.push('/' + this.$route.path.split('/')[1] + '/result', () => {}, () => {})
        }
      },
      /**
       * 計算を実行し、ハンバーガーメニューを閉じる
       */
      Calc(){
        this.evaluate()
        this.toggleMenu()
      },
      /**
       * 座標位置を更新
       */
      updateScroll() {
        /* ナビゲーションがスクロールにあわせて色を変えるため各セクションの座標を取得しています。 */
        if(this.$route.path.indexOf('simple') >= 0 && document.getElementById('basic')){
          let basic = document.getElementById('basic');
          this.axis.basic = basic.getBoundingClientRect().top;

          let envelope = document.getElementById('envelope');
          this.axis.envelope = envelope.getBoundingClientRect().top;

          let heating = document.getElementById('heating');
          this.axis.heating = heating.getBoundingClientRect().top;

          let cooling = document.getElementById('cooling');
          this.axis.cooling = cooling.getBoundingClientRect().top;

          let hotwater = document.getElementById('hotwater');
          this.axis.hotwater = hotwater.getBoundingClientRect().top;

          let ventilation = document.getElementById('ventilation');
          this.axis.ventilation = ventilation.getBoundingClientRect().top;

          let lighting = document.getElementById('lighting');
          this.axis.lighting = lighting.getBoundingClientRect().top;
        }
      },
      /**
       * 保存用モーダルを表示
       */
      showSave(){
        this.$emit('show-save')
      },
      /**
       * 読み込み用モーダルを表示
       */
      showLoad(){
        this.$emit('show-load')
      },
      /**
       * ハンバーガーメニューを表示切り替え
       */
      toggleMenu(){
        this.$emit('toggle-menu')
      },
      ...mapActions({
          update:'data/update',
          setMode:'mode/setMode',
          simpleToDetailShow:'view/simpleToDetailShow',
          setVersion:'general/setVersion'
      }),
      moveConfirm () {
          this.simpleToDetailShow()
      },
    },
    /**
     * ハイライトの初期位置とヘッダの横位置を調整
     */ 
    mounted() {
      //バージョン番号の取得
      this.setVersion()

      window.addEventListener('scroll', this.updateScroll);
      let header = document.getElementById("header");
      window.addEventListener('scroll', _handleScroll, false);

      function _handleScroll() {
        header.style.left = -window.scrollX + "px";
      }
    }
}
</script>

<style lang="scss" scoped>
header{
  display: block;
  width: 100%;
  height: 80px;
  max-height: 170px;
  box-sizing: content-box;
  padding: 0 calc(50vw - 50%);
  background-color: #41B8D4;
  background-size: 100% 120px;
  background-position: 0 0;
  z-index: 990;
  top: 0;
  left: 0;
  position: fixed;
  overflow: visible;
}
/* 大枠のグリッドレイアウト */
.grid_wrapper{
  display: -ms-grid;
  display: grid;
  grid-template-columns: 1fr 210px;
  -ms-grid-columns: 1fr 210px;/* IE11 */
  width: 1000px;
  min-width: 1000px;
  margin: 0 auto;
  position: relative;
  z-index: 1000;
  .upper_grid{
    grid-column: 1;
    grid-row: 1;
    -ms-grid-column: 1;
    -ms-grid-row: 1;
  }
  .lower_grid{
    grid-column: 1;
    grid-row: 2;
    -ms-grid-column: 1;
    -ms-grid-row: 2;
  }
  .right_grid{
    grid-column: 2;
    -ms-grid-column: 2;
    grid-row: 1 / 3;
    -ms-grid-row: 1;/* IE11 */
    -ms-grid-row-span: 2;/* IE11 */
  }
  .nav_box{
    display: none;
    grid-column: 1 / 3;
    grid-row: 3;
    -ms-grid-column: 1;/* IE11 */
    -ms-grid-column-span: 2;/* IE11 */
    -ms-grid-row: 3;/* IE11 */
    background-color: white;
  }
  .white_box{
    grid-column: 1 / 3;
    grid-row: 4;
    -ms-grid-column: 1;/* IE11 */
    -ms-grid-column-span: 2;/* IE11 */
    -ms-grid-row: 4;/* IE11 */
  }
}
/* upper_grid */
.logo_wrapper{
  display: flex;
  margin-top: 10px;
  justify-content: flex-start;
  align-items: center;
  .house_icon{
    display:inline-block;
    width: 56px;
    min-width: 56px;
    height: 56px;
    margin: 5px;
    background: url(/img/all_icons.png) no-repeat; /* スプライト呼び出し */
    background-size: calc( 1725 / 114 * 100% ) auto;
    background-position-x: 0;
  }
  .main_logo{
    display:inline-flex;
    align-items: center;
    width: auto;
    height: 56px;
    margin: 5px;
    font-feature-settings: "palt";
    span:nth-child(1){
      color: white;
      font-size: 20px;
      font-weight: 550;
      white-space: nowrap;
      filter: drop-shadow(0 1px 3px rgba(24, 142, 170, 0.7));
    }
    .selected_program_jutaku{
      display: none;
      margin: 0 5px;
      color: white;
      font-size: 30px;
      font-weight: 550;
      letter-spacing: 4px;
      white-space: nowrap;
      filter: drop-shadow(0 1px 3px rgba(24, 142, 170, 0.7));
    }
    .selected_program_trad{
      display: none;
      margin: 0 5px;
      color: white;
      font-size: 25px;
      font-weight: 550;
      letter-spacing: 1px;
      white-space: nowrap;
      filter: drop-shadow(0 1px 3px rgba(24, 142, 170, 0.7));
    }
    .selected_program_ees{
      display: none;
      margin: 0 5px;
      color: white;
      font-size: 26px;
      font-weight: 550;
      letter-spacing: 2px;
      white-space: nowrap;
      filter: drop-shadow(0 1px 3px rgba(24, 142, 170, 0.7));
    }
    span.root{
      display: none;
      margin: 0 5px;
      color: #0443A8;
      font-size: 16px;
      font-weight: 800;
      white-space: nowrap;
      border-top: 1px #0443A8 solid;
      border-bottom: 1px #0443A8 solid;
    }
    .version{
      display: inline-block;
      margin: 0 0 0 16px;
      padding: 4px 16px;
      font-size: 12px;
      font-weight: bolder;
      color: white;
      background-color: #0443A8;
      border-radius: 3px;
    }
  }
}

/* lower_grid */
.lower_grid{
    .lower_white_box{
    display: none;
    width: fit-content;
    box-sizing: border-box;
    background-color: white;
    border-top-right-radius: 7px;
    border-top-left-radius: 7px;
    border-bottom: 1px white solid;
    padding: 8px 16px 4px;
    .title_command{
      display: flex;
      margin: 0;
      padding: 0;
      span{
        display: inline-block;
        width: 100%;
        padding-right: auto;
        font-weight: bolder;
      }
      input[type="button"]{
        width: 10em;
        margin-bottom: 0;
        padding: 2px 0;
        font-weight: bold;
        letter-spacing: 0.2em;
        background-color: #41B8B6;
        font-size: 12px;
        opacity: 0.8;
        cursor: pointer;
        &:hover{
          opacity: 1;
        }
      }
    }
  }
}

/* right_grid */
.right_grid {
  display: none;
  justify-content: flex-end;
  align-items: flex-end;
  .toresult{
    display: block;
    width: 150px;
    height: 40px;
    margin-bottom: -8px;
    margin-right: 16px;
    position:relative;
    color: transparent;
    background: url(/img/all_icons.png) no-repeat; /* スプライト呼び出し */
    background-size: calc( 1725 / 300 * 100% ) auto;
    background-position-x: calc(1160 / (1725 - 300) * 100%);
    cursor: pointer;
    &.notactive{
      background-position-y: -55px;
      cursor: default;
    }
  }
  .keisan{
    display: block;
    width: 80px;
    min-width: 80px;
    height: 80px;
    margin-bottom: 20px;
    margin-left: -15px;
    font-size: 18px;
    font-weight: bold;
    position:relative;
    color: transparent;
    background: url(/img/all_icons.png) no-repeat; /* スプライト呼び出し */
    background-size: calc( 1725 / 225 * 100% ) auto;
    background-position-x: calc(1500 / (1725 - 225) * 100%);
    background-color: #0443A8;
    border-radius: 50%;
    cursor: pointer;
    &:hover{
      transform: scale(1.025, 1.025);
    }
  }
}
.nav_box{
  display: none;
  background-color:white;
  border-top-right-radius: 5px;
  ul{
    display: flex;
    justify-content: flex-start;
    margin: 12px 8px;
    white-space: nowrap;
    list-style-type: none;
    padding-inline-start: 0;
    background-color:white;
    li{
      display: inline-block;
      padding: 0 12px;
      color: #178EAA;
      border-right: 1px solid #41B8D4;
      &:hover{
        font-weight: bolder;
        background-color: rgba(221, 248, 255, 0.2);
      }
      &.active{
        font-weight:bolder;
        background-color: #DDF8FF;
      }
      &:last-of-type{
        border: none;
      }
      a{
        display: block;
        width: 100%;
      }
    }
  }
}

.white_box{
  display:none;
  height: 20px;
  margin-bottom: 0;
  background-color: white;
  .btn_menu{
    display: none;
  }
}

/* 簡易・詳細入力ルート共通 */
.root_simple header,
.root_detail header{
  height: 170px;
}
.root_simple .logo_wrapper .main_logo .selected_program_jutaku,
.root_detail .logo_wrapper .main_logo .selected_program_jutaku{
  display: inline-block;
}

/* 簡易入力ルート */
.root_simple header{
  span.root.title_simple{
    display: block;
  }
  .lower_grid{
    .lower_white_box{
      display: block;
    }
  }
  .right_grid {
    display: flex;
  }
  .nav_box.nav_simple{
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    max-height: 45px;
    ul li{
      height: 24px;
    }
    .uq_moveToDetail{
      display: flex;
      padding-top: 16px;
      padding-right: 16px;
      max-height:50px;
      position: relative;
      span{
        display: none;
        font-size: 11px;
        line-height:13px;
        background-color: white;
        position:absolute;
        top: 45px;
      }
      input[type="button"]{
        display: flex;
        align-items: center;
        width: 206px;
        max-height: 26px;
        margin:0;
        padding:0 24px;
      }
      &:hover{
        span{
          display: flex;
        }
      }
    }
  }
  .white_box{
    display:block;
  }
}

/* 詳細入力ルート */
.root_detail header{
  span.root.title_detail{
    display: block;
  }
  .lower_grid{
    .lower_white_box{
      display: block;
    }
  }
  .right_grid {
    display: flex;
  }
  .nav_box.nav_detail{
    display: block;
  }
  .white_box{
    display:block;
  }
}

/* 気候風土ルート */
.root_trad header{
  height: 170px;
}
.root_trad .logo_wrapper .main_logo .selected_program_trad{
  display: inline-block;
}
.root_trad header{
  span.root.title_trad{
    display: block;
  }
  .lower_grid{
    .lower_white_box{
      display: block;
    }
  }
  .right_grid {
    display: flex;
  }
  .nav_box.nav_trad{
    display: block;
  }
  .white_box{
    display:block;
  }
}

/* 特定事業主ルート */
.root_ees header{
  height: 170px;
}
.root_ees .logo_wrapper .main_logo .selected_program_ees{
  display: inline-block;
}
.root_ees header{
  span.root.title_ees{
    display: block;
  }
  .lower_grid{
    .lower_white_box{
      display: block;
    }
  }
  .right_grid {
    display: flex;
  }
  .nav_box.nav_ees{
    display: block;
  }
  .white_box{
    display:block;
  }
}

/* IE対応 */

_:-ms-lang(x)::-ms-backdrop, .right_grid input.toresult.notactive {
    background-position-y: -45px;
}
_:-ms-lang(x)::-ms-backdrop, .title_command{
  height: 26px;
  max-height: 26px;
}
_:-ms-lang(x)::-ms-backdrop, .title_command input[type="button"]{
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
_:-ms-lang(x)::-ms-backdrop, .nav_box{
  height: 45px;
  max-height: 45px;
}

/* レスポンシブ（タブレット縦よりウインドウ幅が狭いもの） */
@media screen and (max-width: 1000px) {
  .root_simple header,
  .root_detail header,
  .root_trad header,
  .root_ees header{
    height: auto;
  }
  header{
    width: calc(100% - 16px);
    min-width: 280px;
    height: auto;
    max-height: 100%;
    margin: 0;
    padding: 0 10px;
    .logo_wrapper .main_logo{
      width: auto;
      height: auto;
      flex-wrap: wrap;
      span{
        /* もっといい方法がありそうだけど分からない */
        &:nth-child(1){
          margin: 0;
          font-size: 16px;
        }
        &:nth-child(2){
          font-size: 24px;
        }
        &:nth-child(3){
          font-size: 24px;
        }
        &:nth-child(4){
          font-size: 24px;
        }
        &:nth-child(5){
          font-size: .5em;
        }
        &:nth-child(6){
          font-size: .5em;
        }
      }
    }
    .version{
      font-size: 10px;
      padding: 2px;
      white-space: nowrap;
    }
    .grid_wrapper{
      width: 100%;
      min-width: 280px;
      grid-template-columns: 1fr;
      margin: 0;
      .lower_grid{
        display: none;
        .title_command{
          .load{
            font-size: 16px;
          }
          .save{
            font-size: 16px;
          }
        }
        .lower_white_box{
          display: flex;
          flex-direction: column;
        }
      }
      div.nav_box{
        display: none;
        grid-column: 1;
        -ms-grid-column: 1;
        grid-row: 3;
        -ms-grid-row: 3;/* IE11 */
        ul{
          display: none;
          width: 100%;
          max-width: calc(100% - 16px);
          flex-direction: row;
          justify-content: flex-start;
          flex-wrap: wrap;
          li{
            display: flex;
            align-items: center;
            box-sizing: border-box;
            width: calc(33% - 12px);
            margin: 5px;
            padding: 4px 10px;
            border-right: none;
            border: 1px solid #41B8D4;
            font-size: 16px;
            text-align: center;
          }
        }
        &.nav_simple{
          max-height: 100%;
          .uq_moveToDetail{
            display: none;
          }
        }
      }
      .right_grid{
        display: none;
        flex-direction: row-reverse;
        justify-content: center;
        grid-column: 1;
        -ms-grid-column: 1;
        -ms-grid-column-span: 2;
        grid-row: 4;
        -ms-grid-row: 4;/* IE11 */
        -ms-grid-row-span: 1;/* IE11 */
        background-color: white;
        .toresult{
          width: 45%;
          height: 50px;
          margin: 8px 4px;
          padding: 0;
          color: white;
          background-color:rgba(24, 142, 170, 1);
          background-image: none;
          font-size: 16px;
          &.notactive{
            background-color: #aaa;
          }
        }
        .keisan{
          box-sizing: border-box;
          width: 45%;
          height: 50px;
          margin: 8px;
          padding: 0;
          color: white;
          background-color: #0443A8;
          background-image: none;
          font-size: 16px;
          border-radius: 25px;
        }
      }
      .white_box{
        grid-column: 1;
        -ms-grid-column: 1;
        grid-row: 5;
        -ms-grid-row: 5;/* IE11 */
        background-color: #555;
        border-top-right-radius: 0;
        height: 40px;
        padding: 0;
        .btn_menu{
          display: block;
          width: 100%;
          line-height: 40px;
          color: white;
          margin: 0;
          text-align: center;
        }
      }
    }
  }
  .root_simple .open{
    &.lower_grid{
      display: flex;
    }
    &.right_grid{
      display: flex;
    }
    &.nav_box.nav_simple{
      display: flex;
      flex-direction: column;
      ul{
        display: flex;
      }
      .uq_moveToDetail{
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 16px;
        row-gap: 16px;
        margin-bottom: 36px;
        span{
          display: flex;
          position:relative;
          top:0;
        }
      }
    }
  }
  .root_detail .open{
    &.lower_grid{
      display: flex;
    }
    &.right_grid{
      display: flex;
    }
    &.nav_box.nav_detail{
      display: flex;
      ul{
        display: flex;
      }
    }
  }
  .root_trad .open{
    &.lower_grid{
      display: flex;
    }
    &.right_grid{
      display: flex;
    }
    &.nav_box.nav_trad{
      display: flex;
      ul{
        display: flex;
      }
    }
  }
  .root_ees .open{
    &.lower_grid{
      display: flex;
    }
    &.right_grid{
      display: flex;
    }
    &.nav_box.nav_ees{
      display: flex;
      ul{
        display: flex;
      }
    }
  }
  /* IE11対応 */
  _:-ms-lang(x)::-ms-backdrop, .root_simple header .nav_box.nav_simple,
  _:-ms-lang(x)::-ms-backdrop, .root_detail header .nav_box.nav_detail,
  _:-ms-lang(x)::-ms-backdrop, .root_ees header .nav_box.nav_ees,
  _:-ms-lang(x)::-ms-backdrop, .root_trad header .nav_box.nav_trad{
    display: none;
  }
  _:-ms-lang(x)::-ms-backdrop, .open.nav_box{
    height: auto;
    max-height: 100vh;
  }
}
/* レスポンシブ（1500pxよりウインドウ幅が広いもの） */
@media screen and (min-width: 897px) {
  header{
    width: 100%;
    padding: 0;
    box-sizing: border-box;
  }
}
</style>